import Modal from "react-bootstrap/Modal";
import { useEffect, useMemo, useState } from "react";
import { getQuestions } from "../../context/questions/QuestionActions";
import { useUserContext } from "../../context/users/UserContext";
import { 
  FaQuestionCircle, 
  FaPlus, 
  FaList, 
  FaSave, 
  FaTimes,
  FaTags,
} from 'react-icons/fa';
import './AddQuestionToCanvas.css';

export default function  AddQuestionToCanvas( {showModalQuestion,handleOnSelectQuestion, handleClose, onClickNext, onblurCreateQuestion, newQuestion, setNewQuestion } ) {

    const { authenticatedUser, setAlert } = useUserContext()
    const [questions, setQuestions] = useState([])
    const [selectQuestion, setSelectQuestion] = useState('')
    const [selectCategory, setSelectCategory] = useState('')

    const questionsByCategory = useMemo(() => {
        const map = new Map()
        for (const q of questions) {
            const category = (q.description ?? '').trim() || 'Sin categoría'
            if (!map.has(category)) map.set(category, [])
            map.get(category).push(q)
        }
        for (const list of map.values()) {
            list.sort((a, b) => String(a.question ?? '').localeCompare(String(b.question ?? ''), 'es'))
        }
        return map
    }, [questions])

    const sortedCategories = useMemo(() => {
        return Array.from(questionsByCategory.keys()).sort((a, b) => a.localeCompare(b, 'es'))
    }, [questionsByCategory])

    const questionsInCategory = selectCategory ? (questionsByCategory.get(selectCategory) ?? []) : []

    const fetchData = async () => {
        const response = await getQuestions(
            { path: 'questions', token: authenticatedUser.value, sortBy: 'question', pageSize: 1000 })
        if (response.error) {
            setQuestions([])
        } else {
            setQuestions(response.data)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    // Limpiar estado cuando se cierra el modal
    useEffect(() => {
        if (!showModalQuestion) {
            setSelectQuestion('')
            setSelectCategory('')
        }
    }, [showModalQuestion])


    return (
        <Modal show={showModalQuestion} onHide={handleClose} className='add-question-modal' centered>
            <Modal.Header className='modal-header-simple'>
                <Modal.Title>Agregar Pregunta a la Sesión</Modal.Title>
                <button 
                    type="button" 
                    className="btn-close-simple" 
                    onClick={handleClose}
                    aria-label="Cerrar"
                >
                    <FaTimes />
                </button>
            </Modal.Header>
            
            <Modal.Body className='modal-body-custom'>
                {/* Toggle Section */}
                <div className='toggle-section'>
                    <div className='toggle-container'>
                        <label className='toggle-label' htmlFor='newQuestionToggle'>
                            <FaPlus className='toggle-icon' />
                            Crear nueva pregunta
                        </label>
                        <div className='custom-toggle'>
                            <input
                                type='checkbox'
                                id='newQuestionToggle'
                                checked={newQuestion}
                                onChange={(e) => setNewQuestion(e.target.checked)}
                            />
                            <span className='toggle-slider'></span>
                        </div>
                    </div>
                </div>

                {/* Form Section */}
                <div className={`form-section ${newQuestion ? 'active' : ''}`}>
                    {newQuestion ? (
                        <div className='form-group'>
                            <label className='form-label'>
                                <FaQuestionCircle className='field-icon' />
                                Pregunta personalizada
                                <span className='required-field'>*</span>
                            </label>
                            <input
                                type='text'
                                className='form-control-custom'
                                placeholder='Escribe tu propia pregunta aquí...'
                                onChange={(e) => onblurCreateQuestion(e)}
                            />
                        </div>
                    ) : (
                        <div className='form-group form-group-stacked'>
                            <label className='form-label'>
                                <FaTags className='field-icon' />
                                Categoría
                                <span className='required-field'>*</span>
                            </label>
                            <select
                                className='form-select-custom form-select-category'
                                value={selectCategory}
                                onChange={(e) => {
                                    const next = e.target.value
                                    setSelectCategory(next)
                                    setSelectQuestion('')
                                    handleOnSelectQuestion({ target: { value: '' } })
                                }}
                            >
                                <option value=''>Selecciona una categoría...</option>
                                {sortedCategories.map((category) => (
                                    <option key={category} value={category}>
                                        {category}
                                    </option>
                                ))}
                            </select>

                            <label className='form-label form-label-second'>
                                <FaList className='field-icon' />
                                Pregunta
                                <span className='required-field'>*</span>
                            </label>
                            <select
                                className='form-select-custom'
                                value={selectQuestion}
                                disabled={!selectCategory}
                                onChange={(e) => {
                                    setSelectQuestion(e.target.value)
                                    handleOnSelectQuestion(e)
                                }}
                            >
                                <option value=''>
                                    {selectCategory ? 'Selecciona una pregunta...' : 'Primero elige una categoría'}
                                </option>
                                {questionsInCategory.map((question) => (
                                    <option key={question.questionId} value={question.questionId}>
                                        {question.question}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer className='modal-footer-custom'>
                <button onClick={handleClose} className='cancel-button'>
                    Cancelar
                </button>
                <button onClick={onClickNext} className='save-button'>
                    <FaSave className='me-2' />
                    Continuar
                </button>
            </Modal.Footer>
        </Modal>
    )
}
